/**
 * Chat API
 *
 * @author minkyoung.park@emcast.com
*/
import httpService from '@/api/httpService'
import blockUserHide from '@/api/blockUserService'

const chatApi = {

    // 차시 채팅방 정보(Get lesson chat information)
    // https://clpapi.tinkeredu.co.kr/static/docs/online_learn_chat.html#resources-online-learner-lesson-chatroom-page
    learnChatroomLesson(params) {
        return httpService.get(`/learn/learner/online/${params.learnId}/lesson/${params.lessonId}/chatroom`);
    },

    // 차시 채팅방 대화 등록(Regist lesson chatting)
    // https://clpapi.tinkeredu.co.kr/static/docs/online_learn_chat.html#resources-online-learner-lesson-chats-write
    learnChatroomChat(params) {
        return httpService.post(`/learn/learner/online/${params.learnId}/lesson/${params.lessonId}/chatroom/chat`, params)
    },

    // 차시 채팅방 대화 목록(Get lesson chatting room list)
    // https://clpapi.tinkeredu.co.kr/static/docs/online_learn_chat.html#resources-online-learner-lesson-chats-page
    // TODO jungnam.lee 2023-11-22 Q&A 데이터 중 차단 한 사용자는 임시로 필터링 한다.
    learnChatroomChatList(params) {
        // return blockUserHide(`/learn/learner/online/${params.learnId}/lesson/${params.lessonId}/chatroom/${params.roomId}/chats`, params);
        return httpService.get(`/learn/learner/online/${params.learnId}/lesson/${params.lessonId}/chatroom/${params.roomId}/chats`, params)
    },

    // 차시 채팅방 읽음 처리(Set lesson chat readed)
    // https://clpapi.tinkeredu.co.kr/static/docs/online_learn_chat.html#resources-online-learner-lesson-chats-read
    learnChatroomChatRead(params) {
        return httpService.put(`/learn/learner/online/${params.learnId}/lesson/${params.lessonId}/chatroom/${params.roomId}/read`)
    },

    // 문항 채팅방 정보(Get question chat information)
    // https://clpapi.tinkeredu.co.kr/static/docs/exam_examinee_chat.html#resources-exam-examinee-question-chatroom-page
    examChatroomQuestion(params) {
        return httpService.get(`/exam/examinee/${params.examineeId}/question/${params.questionId}/chatroom`)
    },

    // 문항 채팅 등록(Regist question chatting)
    // https://clpapi.tinkeredu.co.kr/static/docs/exam_examinee_chat.html#resources-exam-examinee-question-chats-write
    examChatroomChat(params) {
        return httpService.post(`/exam/examinee/${params.examineeId}/question/${params.questionId}/chatroom/chat`, params)
    },

    // 문항 채팅 목록(Get question chatting room list)
    // https://clpapi.tinkeredu.co.kr/static/docs/exam_examinee_chat.html#resources-exam-examinee-question-chats-page
    // TODO jungnam.lee 2023-11-22 Q&A 데이터 중 차단 한 사용자는 임시로 필터링 한다.
    examChatroomChatList(params) {
        // return blockUserHide(`/exam/examinee/${params.examineeId}/question/${params.questionId}/chatroom/${params.roomId}/chats`, params);
        return httpService.get(`/exam/examinee/${params.examineeId}/question/${params.questionId}/chatroom/${params.roomId}/chats`, params)
    },

    // 문항 채팅 읽음 처리(Set lesson chat readed)
    // https://clpapi.tinkeredu.co.kr/static/docs/exam_examinee_chat.html#resources-exam-examinee-question-chats-read
    examChatroomChatRead(params) {
        return httpService.put(`/exam/examinee/${params.examineeId}/question/${params.questionId}/chatroom/${params.roomId}/read`)
    },

}

// export const
export default chatApi
